import Video from "twilio-video";

import {
  TW_CONNECTED,
  TW_ROOM_ADD,
  TW_ROOM_REMOVE,
  TW_TOKEN
} from "../constants/actionTypes";
import {CHAT_TOKEN_URL} from "../constants/api";
import {PLATFORM_ANDROID, PLATFORM_IOS} from "../../../constants";
import {isCordova} from "../../../../app";
import {requestAuth} from "../../../../request";

/**
 * Adds a room
 * @param {object} room - room that was connected to
 * @returns {function(dispatch)} thunk to be dispatched
 */
export function addRoom(room) {
  return (dispatch) => {
    dispatch(
      {
        type: TW_ROOM_ADD,
        room: room
      }
    )
  }
}

/**
 * Removes a room
 * @returns {function(dispatch, getState): Promise<any>} promised thunk to be dispatched
 */
export function removeRoom() {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      getState().twilio.video.room.disconnect();
      dispatch({type: TW_ROOM_REMOVE});
      resolve();
    })
  };
}

/**
 * Gets Twilio token
 * @returns {function(dispatch, getState): Promise<any>} promised thunk to be dispatched
 */
export function getToken() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      requestAuth()
        .post(CHAT_TOKEN_URL)
        .send({ identity: getState().user.email })
        .then((res) => {
          if (res.body) {
            dispatch(
              {
                type: TW_TOKEN,
                token: res.body.token
              }
            );
            resolve(
              dispatch(
                {
                  type: TW_CONNECTED,
                  payload: true
                }
              )
            );
          } else {
            dispatch(
              {
                type: TW_CONNECTED,
                payload: false
              }
            );
            reject(new Error("Impossible to get token"));
          }
        })
        .catch(reject);
    });
  }
}

/**
 * Connects to the Twilio video room
 * @param {string} roomName room name
 * @returns {function(dispatch, getState)} thunk to be dispatched
 */
export function connectVideo(roomName) {
  return (dispatch, getState) => {
    return dispatch(getToken()).then(() => {
      const {token} = getState().twilio;
      const connect = () => {
        return Video.connect(token, {
          name: roomName,
          audio: true,
          maxAudioBitrate: 16000,
          video: { height: 480, frameRate: 24, width: 640 }
        });
      };

      if (isCordova()) {
        switch (cordova.platformId) {
          case PLATFORM_ANDROID:
            const permission = () => {
              return new Promise((resolve, reject) => {
                const {permissions} = cordova.plugins;

                permissions.requestPermissions(
                  [
                    permissions.CAMERA,
                    permissions.RECORD_AUDIO,
                    permissions.RECORD_VIDEO
                  ],
                  resolve,
                  reject
                );
              });
            };

            return permission()
              .then(() => {
                return connect();
              });
          case PLATFORM_IOS:
            return cordova.videoconversation.open(roomName.toString(), token);
          default:
            return connect();
        }
      } else {
        return connect();
      }
    });
  }
}
